<div class="siteFilter">
  <div
    data-m-target="Filter by keyword input"
    class="inputGroup__icon search-box"
    [class.search-box--hover]="hovered"
    [class.searchBox--focus]="focused || keyword.length > 0"
    [class.reminderSearchBox]="ppIsReminder"
    (mouseenter)="setHovered(true)"
    (mouseleave)="setHovered(false)"
  >
    @if (!focused && keyword.length === 0) {
      <img [src]="EIconPath.SEARCH_DARK" class="inputSearch__icon" />
    }

    <input
      id="searchBoxKeywords"
      class="searchInput searchInput__name input inputSearch__text"
      [class.inputSearch__no-icon]="focused || keyword.length > 0"
      name="filter-text"
      type="text"
      [placeholder]="placeholder"
      [(ngModel)]="keyword"
      (input)="filter$.next(keyword)"
      (focus)="setFocused(true)"
      (focusout)="setFocused(false)"
    />

    <div class="closeIcon__wrapper">
      @if (keyword.length > 0) {
        <button
          type="button"
          id="searchInputKeywordsClear"
          class="closeIcon"
          (click)="clearSearchKeywords()"
          aria-label="Search input clear"
        >
          <pp-icon [ppSrc]="EIconPath.INTERACTION_DELETE_TEXT" ppColor="inherit"></pp-icon>
        </button>
      }
    </div>
  </div>
</div>
